import { z } from 'zod'
import { type PdvMobileAppSetting } from '../../models/AppSetting'
import { PeripheralDTO, mapDTOToPeripheral } from '../../../peripherals/gateways/DTOs/PeripheralDTO'
import { ServerAppDTO, mapDTOToServerApp } from './ServerAppDTO'
import { mapDTOToVpnSetting, mapVpnSettingToDTO, VpnSettingDTO } from './VpnSettingDTO'

export interface PdvMobileAppSettingInterface {
  server_id?: number
  sat_id?: number
  server?: ServerAppDTO | null
  sat?: PeripheralDTO | null
  is_generate_offline_sale_number?: boolean
  is_generate_and_print_offline_sale?: boolean
  vpn?: VpnSettingDTO | null
}

export const PdvMobileAppSettingDTO: z.ZodSchema<PdvMobileAppSettingInterface> = z.object({
  server_id: z.number().optional(),
  sat_id: z.number().optional(),
  server: ServerAppDTO.nullish(),
  sat: PeripheralDTO.nullish(),
  is_generate_offline_sale_number: z.boolean().optional(),
  is_generate_and_print_offline_sale: z.boolean().optional(),
  vpn: VpnSettingDTO.nullish()
})

export type PdvMobileAppSettingDTO = z.infer<typeof PdvMobileAppSettingDTO>

export function mapPdvMobileAppSettingToDTO (model: PdvMobileAppSetting): PdvMobileAppSettingDTO {
  return {
    server_id: model.server?.id,
    sat_id: model.sat?.id,
    is_generate_offline_sale_number: model.isGenerateOfflineSaleNumber,
    is_generate_and_print_offline_sale: model.isGenerateAndPrintOfflineSale,
    vpn: model.vpn ? mapVpnSettingToDTO(model.vpn) : undefined
  }
}

export function mapDTOToPdvMobileAppSetting (dto: PdvMobileAppSettingDTO): PdvMobileAppSetting {
  return {
    server: dto.server ? mapDTOToServerApp(dto.server) : undefined,
    sat: dto.sat ? mapDTOToPeripheral(dto.sat) : undefined,
    isGenerateOfflineSaleNumber: dto.is_generate_offline_sale_number,
    isGenerateAndPrintOfflineSale: dto.is_generate_and_print_offline_sale,
    vpn: dto.vpn ? mapDTOToVpnSetting(dto.vpn) : undefined
  }
}
